// extracted by mini-css-extract-plugin
export default {"angleProperty":"AngleProperty_angleProperty__1HAyq","inputs":"AngleProperty_inputs__JfWQP","inputWrap":"AngleProperty_inputWrap__AUDGO","input":"AngleProperty_input__eMkPb"};